import React from "react";
import { Grid } from "@mui/material";
import { Copyright } from "./Elements"

const CustomCopyright = () => {
    return <Grid container sx={{ justifyContent: 'center' }} >
        <Copyright>© {new Date().getFullYear()}, Trip Trader. All rights reserved.</Copyright>
    </Grid>
}
export default CustomCopyright